import { Box, Card, CardContent, Grid2, Skeleton, Stack } from '@mui/material';

const VoiceEngineSkeleton = () => {
  return [1, 2, 3, 4, 5, 6].map((_, i) => (
    <Grid2 key={i} size={{ xs: 12, sm: 6, md: 4 }}>
      <Card variant='outlined' sx={{ borderRadius: 2, height: '100%' }}>
        <CardContent>
          <Stack direction='row' justifyContent='space-between' alignItems='center' mb={1}>
            <Skeleton variant='text' width='60%' height={28} />
            <Skeleton variant='rounded' width={80} height={24} />
          </Stack>

          <Skeleton variant='text' width='50%' height={20} />
          <Skeleton variant='text' width='80%' height={18} />
          <Skeleton variant='text' width='90%' height={18} />
          <Box my={1.5} />

          <Stack direction='row' justifyContent='space-between' mb={1}>
            <Box>
              <Skeleton variant='text' width={100} height={16} />
              <Skeleton variant='text' width={80} height={18} />
            </Box>
            <Box>
              <Skeleton variant='text' width={100} height={16} />
              <Skeleton variant='text' width={80} height={18} />
            </Box>
          </Stack>

          <Stack direction='row' gap={1} flexWrap='wrap' mt={1}>
            {[1, 2, 3].map((idx: number) => (
              <Skeleton key={idx} variant='rounded' width={60} height={24} />
            ))}
          </Stack>
        </CardContent>
        <Box p={2} pt={0}>
          <Skeleton variant='rounded' height={36} />
        </Box>
      </Card>
    </Grid2>
  ));
};

export default VoiceEngineSkeleton;
